import { render, staticRenderFns } from "./StudentApply.vue?vue&type=template&id=446ead0a&scoped=true&"
import script from "./StudentApply.vue?vue&type=script&lang=js&"
export * from "./StudentApply.vue?vue&type=script&lang=js&"
import style0 from "./StudentApply.vue?vue&type=style&index=0&id=446ead0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446ead0a",
  null
  
)

export default component.exports